(function () {
  'use strict';

  angular.module('ringbaPortal').component('addAffiliateForm', {
    bindings: {
      existingAffiliate: '<',
      currentCampaign: '<',
      campaignCountry: '<',
      offerInvite: '<',
      onDismiss: '&',
      onSave: '&',
      isRtbEnabled: '<',
    },
    controller: AddAffiliateFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/add-affiliate/add-affiliate-form/add-affiliate-form.view.html'
  });

  function AddAffiliateFormController(
    $filter,
    accountsService,
    affiliateService,
    bsLoadingOverlayService,
    campaignAffiliateService,
    infoService,
    featureFlags,
    numberService,
    offersService,
    toaster,
    utils,
    VuexStore,
    utilities,
    $scope,
    $q
  ) {
    'ngInject';

    const vm = this;
    const render = utilities.safeApply.bind($scope);
    const loaderRefId = 'checkingExistingNumbers';

    vm.assignmentSettings = {
      chargeAccountIfNeeded: false
    };
    vm.campaignSettingsOverride = false;
    vm.campaignCountryNumberSettings = null;
    vm.campaignCanPurchaseNumbers = false;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.selectAffiliate = selectAffiliate;
    vm.handleSubmit = handleSubmit;
    vm.cancelAddNew = cancelAddNew;
    vm.setCampaignSettingsOverride = setCampaignSettingsOverride;
    vm.onToggleAddNumber = onToggleAddNumber;

    function onInit() {
      _loadAvailableNumbers();

      _showCreateNewOrExistingForm();

      if (featureFlags.isOn('rtb')) {
        if (!vm.existingAffiliate) {
          VuexStore.dispatch('dynamicInboundCalls/resetAffiliate', {
            campaignId: vm.currentCampaign.id,
            affiliateId: 'newAffiliate'
          });
        }

        vm.campaignSettingsOverride = VuexStore.getters['dynamicInboundCalls/campaignSettingsOverride'](vm.currentCampaign.id, 'newAffiliate');
        utilities.ngVueEventBus.$on(utilities.ngVueEvents.EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED, _renderFormUpdate);
      }
    }

    function onChanges() {
      if (!vm.existingAffiliate) {
        _loadAffiliates();
      } else {
        vm.selectedAffiliate = angular.copy(vm.existingAffiliate);
        _loadAvailableNumbers();
      }
      _loadCampaignCountry();
    }

    function onDestroy() {
      utilities.ngVueEventBus.$off(utilities.ngVueEvents.EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED, _renderFormUpdate);
    }

    function selectAffiliate(affiliate) {
      if (!affiliate) {
        return;
      }
      _loadAvailableNumbers();
    }

    function handleSubmit() {
      if (vm.offerInvite) {
        return offersService.invitePublisher(accountsService.currentAccountId, vm.currentCampaign.id, vm.selectedAffiliate.id, vm.offerInvitationMessage).then(
          function () {
            _handlePublisherInvited();
          }).catch(utils.errorHandler);
      } else if (_shouldAddOnlyAffiliate()) {
        return _addAffiliate();
      } else {
        return _addNumber();
      }
    }

    function _shouldAddOnlyAffiliate() {
      // RTB campaigns that do not have the pub attached to yet,
      if (vm.isRtbEnabled && !vm.existingAffiliate) {
        return !vm.AddNumber;
      }

      return !_shouldAddNumber();
    }

    function _shouldAddNumber() {
      return vm.numbersToAdd || vm.createNewNumber;
    }

    function _addNumber() {
      const numberObj = {
        campaign: {
          id: vm.currentCampaign.id,
          countryCode: vm.campaignCountry
        },
        affiliateId: vm.selectedAffiliate.id,
        numbersToAdd: vm.numbersToAdd,
        createNewNumber: vm.createNewNumber,
        assignmentSettings: vm.assignmentSettings
      };

      const addNewAffiliate = !vm.existingAffiliate;
      return campaignAffiliateService.addAffiliateWithNumbers(accountsService.currentAccountId, numberObj, addNewAffiliate).then(function (response) {
        if (addNewAffiliate) {
          _handleNewAffiliateAdded(response.data.campaign);
        } else {
          _handleAddNumberToAffiliate();
        }
      }).catch(function (error) {
        utils.errorHandler(error);
        vm.onSave({
          affiliate: campaignAffiliateService.setAffiliateNumber(accountsService.currentAccountId, vm.currentCampaign, vm.selectedAffiliate, [])
        });
      });
    }

    function _addAffiliate() {
      const addNewAffiliate = !vm.existingAffiliate;

      if (!addNewAffiliate) {
        return $q.when({});
      }

      if (vm.isRtbEnabled) {
        // Set Bid Adjustment settings in store
        // Similar to what's being done in `DynamicInbounCalls.vue -> onSaveAll`
        VuexStore.dispatch('dynamicInboundCalls/setRowsPreviousState', {
          campaignId: vm.currentCampaign.id,
          affiliateId: 'newAffiliate',
          val: angular.copy(VuexStore.getters['dynamicInboundCalls/rows'](vm.currentCampaign.id, 'newAffiliate'))
        });

        VuexStore.dispatch('dynamicInboundCalls/saveBidAdjustments', {
          campaignId: vm.currentCampaign.id,
          affiliateId: 'newAffiliate',
          val: angular.copy(VuexStore.getters['dynamicInboundCalls/rowsPreviousState'](vm.currentCampaign.id, 'newAffiliate'))
        });
      }

      const initialPromise = campaignAffiliateService.addAffiliate(accountsService.currentAccountId, vm.currentCampaign.id, vm.selectedAffiliate.id);

      return initialPromise.then(function (response) {
        _handleNewAffiliateAdded(response.data.campaign);
      }).catch(utils.errorHandler);
    }

    function cancelAddNew() {
      vm.onDismiss({
        affiliate: vm.existingAffiliate
      });
    }

    function setCampaignSettingsOverride(affiliateId, val) {
      if (featureFlags.isOn('rtb')) {
        VuexStore.dispatch('dynamicInboundCalls/setCampaignSettingsOverride', { campaignId: vm.currentCampaign.id, affiliateId: affiliateId, val: val });
      }
    }

    function onToggleAddNumber() {
      vm.createNewNumber = _shouldCreateNewNumber(vm.noExistingNumber);
    }

    function _handlePublisherInvited() {
      toaster.pop('success', $filter('translate')('ADD_AFFILIATE_INVITE_SUCCESS'));
      vm.onSave({
        affiliate: null
      });
    }

    function _handleNewAffiliateAdded(campaign) {
      toaster.pop('success', $filter('translate')('ADD_AFFILIATE_EXISTING_NUMBERS_SUCCESS'));
      vm.onSave({
        affiliate: campaignAffiliateService.setAffiliateNumber(accountsService.currentAccountId, campaign, vm.selectedAffiliate, campaign.affiliateNumbers)
      });
    }

    function _handleAddNumberToAffiliate() {
      toaster.pop('success', $filter('translate')('ADD_AFFILIATE_NUMBERS_ADDED_TO_PUBLISHER'));
      vm.onSave({
        affiliate: vm.existingAffiliate
      });
    }

    function _loadAffiliates() {
      affiliateService.getAffiliates(accountsService.currentAccountId)
        .then(function (response) {
          vm.affiliates = $filter('notInArray')(response.data.affiliates, vm.currentCampaign.affiliates, 'id');
        })
        .catch(utils.errorHandler);
    }

    function _loadAvailableNumbers() {
      if (vm.allNumbers) {
        _filterNumbers(vm.allNumbers);
      } else if(vm.checkingExistingNumbers) {
        return;
      } else {
        _showCheckNumbersLoader();
        return numberService.getNumbers(accountsService.currentAccountId)
          .then(function (response) {
            vm.allNumbers = response.data.numbers;
            _filterNumbers(vm.allNumbers);
            _hideCheckNumbersLoader();
          })
          .catch(utils.errorHandler);
      }
    }

    function _loadCampaignCountry() {
      // This code gets the countries, most likely from cache, and sets two variables related to whether or not you can 
      // purchase numbers. These are used to show a notification in the UI and disable the "Add" button. 
      infoService.getCountries()
        .then(function (response) {
          vm.campaignCountryNumberSettings = _.find(response.data, (country) => {
            return country.countryCode === vm.campaignCountry;
          });
          vm.campaignCanPurchaseNumbers = vm.campaignCountryNumberSettings && (vm.campaignCountryNumberSettings.hasLocalNumbers || vm.campaignCountryNumberSettings.hasTollFreeNumbers);
        });
      infoService.getCountriesWithAddressCheck()
        .then(function (response) {
          // TODO: Guard against campaignCountry not set
          vm.campaignCountryWithAddressCheck = _.find(response.data, function (o) {
            return o.countryCode === vm.campaignCountry;
          });
          // This checks for address requirement of both local and toll free numbers
          vm.addressRequirementFulfilled =
            (vm.campaignCountryWithAddressCheck && vm.campaignCountryWithAddressCheck.hasLocalNumbers && vm.campaignCountryWithAddressCheck.addressRequirementFullfilledForLocalNumbers)
            ||
            (vm.campaignCountryWithAddressCheck && vm.campaignCountryWithAddressCheck.hasTollFreeNumbers && vm.campaignCountryWithAddressCheck.addressRequirementFullfilledForTollFreeNumbers);
        })
        .catch(utils.errorHandler);
    }

    function _showCheckNumbersLoader() {
      vm.checkingExistingNumbers = true;
      bsLoadingOverlayService.start({
        referenceId: loaderRefId
      });
    }

    function _hideCheckNumbersLoader() {
      vm.checkingExistingNumbers = false;
      bsLoadingOverlayService.stop({
        referenceId: loaderRefId
      });
    }

    function _filterNumbers(allNumbers) {
      if (vm.selectedAffiliate) {
        vm.numbers = _.filter(allNumbers, function checkIfNumberIsEligibleToCampaign(number) {
          return numberService.isNumberEligibleForCampaignOrOffer(number, vm.campaignCountry, vm.selectedAffiliate);
        });

        _showCreateNewOrExistingForm();
      }
    }

    function _showCreateNewOrExistingForm() {
      vm.noExistingNumber = vm.numbers && !vm.numbers.length;
      vm.createNewNumber = _shouldCreateNewNumber(vm.noExistingNumber);
    }

    function _shouldCreateNewNumber(noExistingNumber) {
      if (vm.AddNumber !== undefined && !vm.AddNumber) {
        return false;
      }
      return noExistingNumber || vm.createNewNumber;
    }

    function _renderFormUpdate() {
      vm.campaignSettingsOverride = VuexStore.getters['dynamicInboundCalls/campaignSettingsOverride'](vm.currentCampaign.id, 'newAffiliate');
      render();
    }

  }
})();
